import Styled from 'styled-components';

import { OrderedList } from './List';

export const ListNumber = Styled(OrderedList)`
  counter-reset: decimal-bold;
  list-style-type: none;
`;

ListNumber.displayName = 'ListNumber';
